import { z } from 'zod';

export const ImportDataSchema = z.object({
  metrics_settings: z.record(z.uuid(), z.object({}).passthrough()).nullable(),

  preset: z.object({}).passthrough().nullable(),

  reports: z.array(z.object({}).passthrough()).nullable(),

  gpt_groups: z.record(z.uuid(), z.object({}).passthrough()).nullable(),
});
export function replaceValuesDeep<T>(data: T, replacements: Record<string, string>): T {
  // массив
  if (Array.isArray(data)) {
    return data.map((item) => replaceValuesDeep(item, replacements)) as T;
  }

  // объект
  if (data !== null && typeof data === 'object') {
    const result: Record<string, any> = {};

    for (const [key, value] of Object.entries(data)) {
      result[key] = replaceValuesDeep(value, replacements);
    }

    return result as T;
  }

  if (typeof data === 'string' && replacements[data] !== undefined) {
    return replacements[data] as T;
  }

  return data;
}
